import { Container, Service } from 'typedi';
import { ILoginModel } from '../models';
import { INativeService } from '../../native/models/INativeService';
import { LoaderManager } from '../../../loaders/LoaderManager';
import { Features } from '../../../models/enums/general-enums';
import { IFeatureAvailability } from '../../feature/feature-availability/feature-availability-interface';
import { FeatureAvailabilityToken, WindowToken } from '../../../injection-tokens';

@Service()
export abstract class LoginDataBuilder<T extends ILoginModel> {
    private readonly _featureAvailability: IFeatureAvailability;
    protected readonly _window: Window;

    public abstract Build(data: any): Promise<T>;

    protected get _nativeServicePromise(): Promise<INativeService> {
        return LoaderManager.Instance.NativeServiceLoader.Instance;
    }

    constructor() {
        this._window = Container.get(WindowToken);
        this._featureAvailability = Container.get(FeatureAvailabilityToken);
    }

    protected shouldSendLoginCountry = (): boolean => {
        return this._featureAvailability.IsFeatureEnabled(Features.SCV);
    };

    protected _setLoginNativeProps = async (loginData: T) => {
        const nativeService = await this._nativeServicePromise;
        const nativeStoreData = nativeService?.getNativeStoreData();

        return {
            ...loginData,
            ...(nativeStoreData && {
                AppID: nativeStoreData.AppID,
                AppsFlyerID: nativeStoreData.AppsFlyerID,
                IDFV: nativeStoreData.IDFV,
                BundleId: nativeStoreData.Bundle,
                DeviceId: nativeStoreData.IDFA,
                FirebaseAppID: nativeStoreData.FirebaseAppID,
                FirebaseAppInstanceID: nativeStoreData.FirebaseAppInstanceID,
            }),
        };
    };
}
